import React from 'react';
import { useLocation } from 'react-router-dom';
import { isJulySpecialActive, JULY_SPECIAL_NOTICE } from './washPackages';

/** Red promotional banner shown while the July wash special is active. */
function JulySpecialBanner() {
  const location = useLocation();
  if (!isJulySpecialActive()) return null;
  if (location.pathname.startsWith('/adminpfy9665k01')) return null;

  return (
    <div
      role="status"
      style={{
        background: '#fef2f2',
        color: '#dc2626',
        borderBottom: '2px solid #dc2626',
        padding: '0.75rem 1rem',
        textAlign: 'center',
        fontWeight: 'bold',
        fontSize: '0.95rem',
        lineHeight: 1.4,
      }}
    >
      {JULY_SPECIAL_NOTICE}
    </div>
  );
}

export default JulySpecialBanner;
